/**
 * Sign In page with Clerk integration
 */


import { SignIn } from '@clerk/clerk-react';

export default function SignInPage() {
  return (
    <div className='min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800'>
      <div className='w-full max-w-md'>
        <div className='text-center mb-8'>
          <h1 className='text-3xl font-bold text-gray-900 dark:text-white'>
            Bienvenido a Grade
          </h1>
          <p className='text-gray-600 dark:text-gray-400 mt-2'>
            Inicia sesión en tu cuenta para continuar
          </p>
        </div>

        <div className='bg-white dark:bg-gray-900 shadow-xl rounded-lg p-6'>
          <SignIn
            appearance={{
              elements: {
                card: 'shadow-none',
                headerTitle: 'hidden',
                headerSubtitle: 'hidden',
              },
            }}
            routing='path'
            path='/auth/sign-in'
            afterSignInUrl='/dashboard'
            signUpUrl='/auth/sign-up'
          />
        </div>

        <div className='text-center mt-6'>
          <p className='text-sm text-gray-600 dark:text-gray-400'>
            Sistema de Evaluación Inteligente para LLMs
          </p>
        </div>
      </div>
    </div>
  );
}
